import { FSCollections } from '@src/constants/database';

import { DASHBOARDS_FORMS } from '../../../constants';
import { getDeviationsActionButtons } from '../actionButtons/deviationsActionButtons';
import { renderTableContent } from '../renderers/tableRenderer';
import {
  SEARCHABLE_COLUMNS_NAMES,
  useDeviationsTableData,
} from '../transformers/deviationsTaskComplianceTransformer';

import type { WidgetConfig } from './types';
import { translateString } from '@src/util/intl/translateString';

export const deviationsFromTaskCompliance: WidgetConfig = {
  activeSingleFilter: true,
  initialFilters: {
    [SEARCHABLE_COLUMNS_NAMES.SCHEDULE_NAME]: {
      value: '',
      label: translateString('dashboards.deviations.column.taskName'),
      valueTranslated: '',
      valueType: 'string',
      clearValue: '',
      key: SEARCHABLE_COLUMNS_NAMES.SCHEDULE_NAME,
    },
    [SEARCHABLE_COLUMNS_NAMES.SCHEDULE_TASK_SUMMARY_NAME]: {
      value: '',
      label: translateString('dashboards.deviations.column.templateName'),
      valueTranslated: '',
      valueType: 'string',
      clearValue: '',
      key: SEARCHABLE_COLUMNS_NAMES.SCHEDULE_TASK_SUMMARY_NAME,
    },
  },
  collectionName: FSCollections.TABLES,
  componentType: DASHBOARDS_FORMS.DEVIATIONS_FROM_TASK_COMPLIANCE,
  useDataHook: useDeviationsTableData,

  renderContent: renderTableContent,

  getActionButtons: getDeviationsActionButtons,
};
